export default () => ({
  isOpenLeft: false,
  isOpenRight: false,
  menu: null,
  subMenu: 1,
  activeButton: null,
  showRightHover: null,     
  hoveredParent: null,
  hoveredChild: null,
  hoveredGrandchild: null,
  toggleMenu(index, side) {
    if (this.activeButton === index && 
        ((side === "left" && this.isOpenLeft) || (side === "right" && this.isOpenRight))) {
      this.closeMenu(side);
      return;
    }
    
    this.openMenu(index, side);
  },
  openMenu(index, side) {
    this.isOpenLeft = false;
    this.isOpenRight = false;
    
    this.menu = index;
    this.activeButton = index;
    this.subMenu = 1;
    this.hoveredChild = null; 
    this.hoveredGrandchild = null;
    
    if (side === "left") {
      this.isOpenLeft = true;
    } else if (side === "right") {
      this.isOpenRight = true;
    }
    
    this.$dispatch("bg-toggle", true);
    window.Grebify.noScroll(true);
  },
  closeMenu(side) {
    if (side === "left") {
      this.isOpenLeft = false;
    } else if (side === "right") {
      this.isOpenRight = false;
    } else {
      this.isOpenLeft = false;
      this.isOpenRight = false;
    }
    
    this.activeButton = null;
    this.hoveredChild = null;
    this.hoveredGrandchild = null;
    this.$dispatch("bg-toggle", false);
    if (!this.isOpenLeft && !this.isOpenRight) {
      window.Grebify.noScroll(false);
    }
  },
  closeAllMenus() {
    this.isOpenLeft = false;
    this.isOpenRight = false;
    this.activeButton = null;
    this.hoveredChild = null;
    this.hoveredGrandchild = null;
    this.$dispatch("bg-toggle", false);
    window.Grebify.noScroll(false);
  },
  mouseEnter(index, side) {
    this.openMenu(index, side);
  },
  mouseLeave(side) {
    this.closeMenu(side);
  },
  setSubMenu(index) {
    this.subMenu = index;
    this.hoveredChild = null; 
    this.hoveredGrandchild = null;
  },
});